exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep [type=\"checkbox\"]:checked + label:before {\n  border-right: 2px solid #1594A6 !important;\n  border-bottom: 2px solid #1594A6 !important; }\n\n.main-card-padding {\n  margin: 0 auto;\n  width: 100%;\n  min-height: 560.8px;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.success-icon {\n  color: #c4d69b;\n  margin: 0 auto; }\n\n.error-icon {\n  color: #cb6f67;\n  margin: 0 auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/login/login.component.scss
// module id = ../../../../../src/app/components/login/login.component.scss
// module chunks = main